/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getParkReview = /* GraphQL */ `query GetParkReview($id: ID!) {
  getParkReview(id: $id) {
    id
    parkId
    title
    description
    rating
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetParkReviewQueryVariables,
  APITypes.GetParkReviewQuery
>;
export const listParkReviews = /* GraphQL */ `query ListParkReviews(
  $filter: ModelParkReviewFilterInput
  $limit: Int
  $nextToken: String
) {
  listParkReviews(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      parkId
      title
      description
      rating
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListParkReviewsQueryVariables,
  APITypes.ListParkReviewsQuery
>;
export const getPointOfIntrest = /* GraphQL */ `query GetPointOfIntrest($id: ID!) {
  getPointOfIntrest(id: $id) {
    id
    parkId
    name
    description
    latitude
    longitude
    pointType
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPointOfIntrestQueryVariables,
  APITypes.GetPointOfIntrestQuery
>;
export const listPointOfIntrests = /* GraphQL */ `query ListPointOfIntrests(
  $filter: ModelPointOfIntrestFilterInput
  $limit: Int
  $nextToken: String
) {
  listPointOfIntrests(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      parkId
      name
      description
      latitude
      longitude
      pointType
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPointOfIntrestsQueryVariables,
  APITypes.ListPointOfIntrestsQuery
>;
export const getUserSavedParks = /* GraphQL */ `query GetUserSavedParks($id: ID!) {
  getUserSavedParks(id: $id) {
    id
    parkId
    group
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserSavedParksQueryVariables,
  APITypes.GetUserSavedParksQuery
>;
export const listUserSavedParks = /* GraphQL */ `query ListUserSavedParks(
  $filter: ModelUserSavedParksFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserSavedParks(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      parkId
      group
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserSavedParksQueryVariables,
  APITypes.ListUserSavedParksQuery
>;
